import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BillValidationResult,
  BillValidationPayload,
} from "features/bbps/biller/billerFlowTypes";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

interface BillValidationState {
  loading: boolean;
  data?: BillValidationResult;
  error?: NormalizedError | null;
  isBillValidationSuccess: boolean;
}

const initialState: BillValidationState = {
  loading: false,
  data: undefined,
  error: null,
  isBillValidationSuccess: false,
};

const billValidationSlice = createSlice({
  name: "billValidation",
  initialState,
  reducers: {
    billValidationRequested(
      state,
      _action: PayloadAction<BillValidationPayload>,
    ) {
      state.loading = true;
      state.error = null;
      state.isBillValidationSuccess = false;
    },
    billValidationSucceeded(
      state,
      action: PayloadAction<BillValidationResult>,
    ) {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
      state.isBillValidationSuccess = true;
    },
    billValidationFailed(state, action: PayloadAction<NormalizedError>) {
      state.loading = false;
      state.error = action.payload;
      state.isBillValidationSuccess = false;
    },
    billValidationReset() {
      return initialState;
    },
  },
});

export const {
  billValidationRequested,
  billValidationSucceeded,
  billValidationFailed,
  billValidationReset,
} = billValidationSlice.actions;

export default billValidationSlice.reducer;
